import React from "react";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function HeaderContainer({ children, className, ...props }: IProps) {
    const classNames = ["userful-header-container", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
